<template>
  <div class="box">
    <div class="mainform g-3 pb-4">
      <h3>Change Password</h3>

      <p>
        Dear {{fullname}},
      </p>

      <p>
        please change your password.
        Please note that the password must contain characters from three of the following four character classes: Upper
        case letters, lower case letters, numbers. The minimum length is 12 characters. Number sequences (e.g. 1234) and
        year patterns (e.g. 1990, 2025) are not allowed.
      </p>

      <div v-show="errorstring.de" class="alert alert-danger mb-5">
        {{ store.getters.i18n(errorstring) }}
      </div>

      <div>
        <form @submit.prevent="updatePassword" class="form-horizontal">
          <div class="row">
            <div class="col-sm-12 position-relative formitem_parent">
              <label class="form-label" for="musername">Temporary password</label>
              <input
                  type="password"
                  required
                  autocomplete="off"
                  v-model.trim="tempPassword"
                  id="temppassword"
                  class="form-control"
              />
            </div>

            <div class="col-sm-12 position-relative formitem_parent">
              <label class="form-label" for="mpassword">New Password</label>
              <input
                  type="password"
                  required
                  autocomplete="off"
                  v-model.trim="newPassword"
                  id="password1"
                  class="form-control"
              />
            </div>

            <div class="col-sm-12 position-relative formitem_parent">
              <label class="form-label" for="mpassword">New Password (repeat)</label>
              <input
                  type="password"
                  required
                  autocomplete="off"
                  v-model.trim="repeatNewPassword"
                  id="password2"
                  class="form-control"
                  @focusout="checkPasswords" @keyup="checkPasswords"
              />
            </div>
          </div>

          <div class="row mt-4 clearfix noprint">
            <div class="col d-flex justify-content-start flex-row-reverse">
              <button
                  class="btn btn-primary m-2"
                  :disabled="!fieldsFilled"
                  type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, onBeforeMount, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {TranslatedText} from "@/store/types";
import crud from "@/crud";

const store = useStore();
const router = useRouter();

const tempPassword = ref('');
const newPassword = ref('');
const repeatNewPassword = ref('');

const fullname = computed(() => {
  return store.state.i.me.firstname + ' ' + store.state.i.me.lastname;
})

const errorstring = ref<TranslatedText>({de: '', en: ''})
const fieldsFilled = computed(() => tempPassword.value.length > 0 && newPassword.value.length > 0 && newPassword.value === repeatNewPassword.value);

onBeforeMount(async () => {
  if (!store.state.tempPassword) {
    await router.replace({name: 'Welcome'});
  }
});

const checkPasswords = (e: FocusEvent | KeyboardEvent) => {
  if (e.type === 'keyup') {
    // Wenn wir den Fehler bereits zeigen dann auch direkt beim tippen wieder ausblenden wenn es irgendwann passt.
    if (errorstring.value.de != '' && newPassword.value === repeatNewPassword.value) {
      errorstring.value = {de: '', en: ''};
    }
    return;
  }

  if (newPassword.value !== repeatNewPassword.value) {
    errorstring.value = {de: "Passwords don't match", en: "Passwords don't match"};
  } else {
    errorstring.value = {de: '', en: ''};
  }
};

const updatePassword = async () => {
  if (!fieldsFilled.value) {
    return;
  }

  errorstring.value = {de: '', en: ''};

  const changePasswordRes = await crud('/changePassword', {
    jwt: store.state.jwt,
    tempPassword: tempPassword.value,
    newPassword: newPassword.value,
    repeatNewPassword: repeatNewPassword.value,
  });

  if(changePasswordRes.success) {
    store.commit('setTempPassword', false);
    router.replace({ name: changePasswordRes.show_onboarding ? 'Step1' : 'Welcome' })
  } else {
    errorstring.value = {de: changePasswordRes.error ?? '', en: changePasswordRes.error ?? ''};
  }
};
</script>
